import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {SettingsComponent} from './components/settings/settings.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';

import { SharedModule} from '../shared/shared.module';
import { VentaSelectorComponent } from './components/venta-selector/venta-selector.component';
import {FileModule} from "../files/file.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        FileModule
    ],
    exports: [
        VentaSelectorComponent,
    ],
    declarations: [SettingsComponent, DashboardComponent, VentaSelectorComponent]

})

export class ConfigModule {
}





// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/config/config.module.ts